const ServerStatus = {
  server_success: 200,
  server_failed: 500,
  unauthorized: 401, // bad format issued token or expired token
  not_found: 404, // data not available
  bad_request: 400,
  service_unavailable: 503,
  timeout: 'TIMEOUT_ERROR',
  network_error: 'NETWORK_ERROR'
}

export default ServerStatus
